export const uid = (): string =>
  'm_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);

export const nowISO = (): string => new Date().toISOString();
